import React from 'react'

export const ArrowBackIcon = (color = '#171E24', width = 16, height = 16) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.0005 7.00022H3.83047L8.71047 2.12022C9.10047 1.73022 9.10047 1.09021 8.71047 0.700215C8.32047 0.310215 7.69047 0.310215 7.30047 0.700215L0.710469 7.29022C0.320469 7.68022 0.320469 8.31022 0.710469 8.70022L7.30047 15.2902C7.69047 15.6802 8.32047 15.6802 8.71047 15.2902C9.10047 14.9002 9.10047 14.2702 8.71047 13.8802L3.83047 9.00022H15.0005C15.5505 9.00022 16.0005 8.55022 16.0005 8.00022C16.0005 7.45022 15.5505 7.00022 15.0005 7.00022Z"
        fill={color}
      />
    </svg>
  )
}
